import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CardMedia from "@mui/material/CardMedia";
import Carousel from "react-material-ui-carousel";
interface Item {
  name: string;
  description: string;
  link: string;
  img: string;
}
const base_url = `https://www.syon.co.jp/syon-carousel/`;

const App = () => {
  var items: Item[] = [
    // {
    //   name: "Random Name #1",
    //   description: "#1",
    //   link: "",
    //   img: `${base_url}top01.png`,
    // },
    {
      name: "#2 aws",
      description: "#2",
      link: "https://www.syon.co.jp/aws%E3%83%91%E3%83%BC%E3%83%88%E3%83%8A%E3%83%BC%E3%81%AB%E8%AA%8D%E5%AE%9A%E3%81%95%E3%82%8C%E3%81%BE%E3%81%97%E3%81%9F/",
      img: `${base_url}top02.png`,
    },
    {
      name: "#3 box",
      description: "#3",
      link: "https://www.syon.co.jp/syon-box/index.html",
      img: `${base_url}top03.png`,
    },
    {
      name: "#4 googleworkspace",
      description: "#4",
      link: "https://www.syon.co.jp/syon-googleworkspace/index.html",
      img: `${base_url}top04.png`,
    },
    {
      name: "#5 syon tetra",
      description: "#5",
      link: "https://www.syon.co.jp/products/",
      img: `${base_url}top05.png`,
    },
  ];

  return (
    <Box>
      <Carousel>
        {items.map((item, i) => (
          <Item key={i} item={item} />
        ))}
      </Carousel>
    </Box>
  );
};

function Item(props: any) {
  const { item } = props;
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
    >
      <Grid item md={12} xs={3}>
        <Box sx={{ minWidth: 300, maxWidth: "md" }}>
          <a href={`${item.link}`} target="_blank" rel="noreferrer">
            <CardMedia
              component="img"
              sx={{
                width: `calc(100vh-100px)`,
                height: `calc(100vh-50px)/3.5`,
              }}
              image={`${item.img}`}
              alt=""
            />
          </a>
        </Box>
      </Grid>
    </Grid>
  );
}

export default App;
